// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

// Current year for copyright
const currentYear = new Date().getFullYear();
document.querySelectorAll('.current-year').forEach((el) => {
  el.innerHTML = currentYear;
}
);

// Dynamicly set top for .toolbar-fixed .nav-wrapper to the height of .gin-secondary-toolbar
const updateNavWrapperDimensions = () => {
  const ginSecondaryToolbar = document.querySelector('.gin-secondary-toolbar');
  const verticalTrayActive = document.querySelector('.toolbar-menu-administration');
  if (ginSecondaryToolbar) {
    const ginSecondaryToolbarHeight = ginSecondaryToolbar.offsetHeight;
    let verticalTrayWidth = verticalTrayActive.offsetWidth;
    const navWrapper = document.querySelector('.toolbar-fixed .nav-wrapper');
    if (navWrapper) {
      const additionalHeight = window.innerWidth <= 975 ? 39 : 0;
      navWrapper.style.setProperty('top', `${ginSecondaryToolbarHeight + additionalHeight}px`);
      navWrapper.style.setProperty('left', `${verticalTrayWidth}px`);

      const popMenu = document.querySelector('#toolbar-item-administration');
      popMenu.addEventListener('click', () => {
        console.log('clicked');
      });
    }
  }
};

// Initial calculation
updateNavWrapperDimensions();

// Recalculate on window resize
window.addEventListener('resize', updateNavWrapperDimensions);

// Brightcove video divs
const iframeBrightcove = document.querySelectorAll('.field--name-body iframe[src*="players.brightcove.net"]');
if (iframeBrightcove.length > 0) {
  // add ratio to the parent div
  iframeBrightcove.forEach((iframe) => {
    const parentDiv = iframe.parentElement;
    parentDiv.classList.add('ratio', 'ratio-16x9', 'iframe-container');
  });
}

// Get the current URL
const currentUrl = window.location.href;

// Switch the active tab based on the current URL
const tabs = document.querySelectorAll('.regions-menu ul li a');
const tab_global = document.querySelector('.regions-menu ul li a[href="/"]');
let notActiveCount = 0;
tabs.forEach((tab) => {
  const tabHref = tab.getAttribute('href');
  const regionClasses = {
    '/anz': 'region-anz',
    '/asia': 'region-asia',
    '/emea': 'region-emea',
    '/': 'region-global'
  };
  if (regionClasses[tabHref]) {
    tab.classList.add(regionClasses[tabHref]);
  }
  if (currentUrl.includes(tabHref) && tabHref.length > 2) {
    tab.classList.add('active');
  } else {
    notActiveCount++;
    tab.classList.add('not-active');
  }
  //console.log('count', notActiveCount, tabHref);
});
if (notActiveCount >= 7) {
  tab_global.classList.add('active');
  tab_global.classList.remove('not-active');
}
